import debug from 'debug';

// Can't use configuration value for this namespace, since this value needs to exist all the time (it also shouldn't be anything else other than `payroll`)
export const logger = debug('launch');

export const enable = debug.enable;
